import config from './globals/config';

export default function (body, trailersSlices) {
  let active = trailersSlices.find('.active');
  config.activeTrailer = active;

  let trailerNum = active.data('color');
  let activeColor = 'trailer' + trailerNum;

  body.removeClass(function (index, css) {
    return (css.match(/(^|\s)trailer\S+/g) || []).join(' ');
  }).addClass(activeColor);
}
